<template>  
<div class="bidding-main">
    <div>
        <el-row :gutter="35" style="margin-top: 20px;">
            <el-col :xs="24" :sm="24" :md="24" v-for="(item_bidding) in bidding_list" :key="item_bidding.id">
                <div class="shebei-item" style="width: 100%; height:auto">
                    <div class="backgd" style="text-align: left">
                        
                        <div class="bidding-item">
                            <h3 class="title">
                                <a :href="'#/bidding/' + item_bidding.id">  
                                    {{ item_bidding.title }}
                                </a>
                            </h3>
                            <p class="description" >{{ item_bidding.description }}</p>
                            
                            <el-table :data="item_bidding.item">
                                <el-table-column label="物料名称" prop="title"></el-table-column>
                                <el-table-column label="要求" prop="description"></el-table-column>
                            </el-table>
                            
                            <dl class="date">
                            
                                <dt class="key">
                                    <img class="avatar" :src="url_pre + '/storage/' + item_bidding.avatar"  alt="" >
                                </dt>
                                <dd class="val">{{ item_bidding.name }}</dd>
                            
                                <template v-if="item_bidding.shop_id">
                                    <dt class="key">店铺：</dt>
                                    <dd class="val">
                                        <a :href="'#/shops/index/' + item_bidding.shop_id ">{{ item_bidding.shop_name }}</a>
                                    </dd>
                                </template>
                                

                                <dt class="key">发布日期：</dt>
                                <dd class="val">{{ item_bidding.created_at.split(' ')[0] }}</dd>

                                <dd style="text-align: right;flex-grow: 1;">
                                    <a :href="'#/bidding/' + item_bidding.id">查看详情</a>
                                </dd>
                            </dl>

                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>

    <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container"
            style="line-height: 5.1em;margin-top: 60px;width: 100%">
        <div data-v-6af373ef="" class="el-pagination is-background">
            <span class="el-pagination__total">共 {{ zuoshuL }} 条</span>
            <el-pagination
                    style="float: left"
                    layout="prev, pager, next"
                    @current-change="yedianji"
                    :total="zuidayema*10">
            </el-pagination>
        </div>
    </div>
</div>

</template>

<script>

export default {

name:'shop_bidding',
data:function(){
    return {
        shop_id:0,
        token:'',
        zuoshuL:'',
        zuidayema :'',

        bidding_list : [],
        bidding_search_key:'',         // 搜索关键字
        url_pre:'',
        current_page:1,
    }

},

methods:{
    
    init:function(){

        this.shop_id = this.$route.params.id;
        this.url_pre = window.config.api_url;
        this.get_list();
        
    },

    get_list:function(){

        var t = this
        
        // var url = window.config.api_url + '/college/shop/' + this.shop_id +  '/bidding';
        var url = window.config.api_url + '/college/shop/' + this.shop_id +  '/bidding';

        url += '?key=' + this.bidding_search_key;
        url += '&page=' + this.current_page;

        t.axios.get(url).then(res => {

            t.bidding_list = res.data.data;

            t.bidding_list.forEach( item=>{
                console.log( item );
                t.zuoshuL = res.data.total
                t.zuidayema = res.data.last_page
            });

        })

    },
    yedianji(e) {
        this.current_page = e;
        this.get_list(e)
    }

},
created:function(){

    this.init();

}

}
</script>

<style lang="less" scoped>

.bidding-main{

    max-width:1200px;
    margin:0 auto;
}
.shebei-item{

    background-color:#fff;
}
.bidding-item {

    position:relative;
    padding:20px;

    .title{
        font-size:24px;

    }
    .description{

        margin-top:10px;
        // height:80px;
    }
    .date{

        margin-top:10px;
        display: flex;
        align-items: center;

        .avatar{
            width:30px;
            height:30px;
            border-radius:15px;
        }
        .key{
            display:inline-block;
            margin-right:10px;
        }

        .val{
            display:inline-block;
            margin-right:20px;
        }


    }
    .status{

        position:absolute;
        top:20px;
        right:20px;
        font-size: 24px;
        
        .active{
            color:rgb(75, 210, 70)
        }
        .deactive{
            color:gray;
        }
        
    }

    .reply{

        margin-top:10px;
        display:flex;

        input{
            border: 1px solid #dcdfe6 !important;
        }
    }
}
</style>